import { PropsWithChildren, useCallback, useState } from "react";

export default function CClipboard(props: PropsWithChildren & { className?: string }) {
  const [copied, setCopied] = useState(false);
  const copyContent = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(props.children as string);
      console.log("Content copied to clipboard");
      setCopied((v) => !v);
      setTimeout(() => {
        setCopied((v) => !v);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }, [props.children]);

  return (
    <pre>
      <code className="lang-typescript">
        {props.children}
        <button onClick={copyContent} style={{ position: "absolute", top: 10, right: 20 }}>
          {copied ? "Copied" : "Copy"} <i className="fa fa-clone"></i>
        </button>
      </code>
    </pre>
  );
}
